module.exports = __webpack_public_path__ + "img/currency1.ce29cdc4.png";